/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import GeneralEntryExitDetailsApp from "../../Functionality/EntryAndExitForms/GeneralEntryExitDetailsApp";
import GeneralEntryExitDetails from "./GeneralEntryExit/Details/GeneralEntryExitDetails";
import PlantMaterialControlDetails from "./PlantMaterialControl/Details/PlantMaterialControlDetails";
import { ENTRY_AND_EXIT_FORMS } from "../../Model/Model";
import CratesAndPalletsReturnDetails from "./CratesAndPalletsReturn/Details/CratesAndPalletsReturnDetails";
import PoultryTruckExitDetails from "./PoultryTruckExit/Details/PoultryTruckExitDetails";
import LivePoultryTruckDetails from "./LivePoultryTruck/Details/LivePoultryTruckDetails";

/**
 * Detail of an entry and exit form.
 *
 * Every form type is read with the same service, so the information is loaded
 * once and the type of the form tells which detail is displayed for it.
 *
 * @returns {JSX.Element} Detail of the form matching its type.
 */
const EntryAndExitFormDetails = () => {
    const {
        t,
        navigate,
        DEV,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        evidence,
        form,
        statusId,
        movementDirectionOption,
        movementDirectionSection,
        showBadge,
        pendingGateTrans,
        goBack
    } = GeneralEntryExitDetailsApp();

    const DetailsByForm = {
        [ENTRY_AND_EXIT_FORMS.PLANT_MATERIAL_CONTROL.key]: PlantMaterialControlDetails,
        [ENTRY_AND_EXIT_FORMS.CRATES_AND_PALLETS_RETURN.key]: CratesAndPalletsReturnDetails,
        [ENTRY_AND_EXIT_FORMS.POULTRY_TRUCK_EXIT.key]: PoultryTruckExitDetails,
        [ENTRY_AND_EXIT_FORMS.LIVE_POULTRY_TRUCK.key]: LivePoultryTruckDetails
    };

    const Details = DetailsByForm[form?.key] || GeneralEntryExitDetails;

    return (
        <Details
            t={t}
            navigate={navigate}
            DEV={DEV}
            permission={permission}
            contentCardRef={contentCardRef}
            contentTableRef={contentTableRef}
            containerCardRef={containerCardRef}
            containerTableRef={containerTableRef}
            item={item}
            evidence={evidence}
            form={form}
            statusId={statusId}
            movementDirectionOption={movementDirectionOption}
            movementDirectionSection={movementDirectionSection}
            showBadge={showBadge}
            pendingGateTrans={pendingGateTrans}
            goBack={goBack}
        />
    );
};

export default EntryAndExitFormDetails;
